import { TimechiefClient as TC } from "../api/TimechiefClient";
import { BffBaseURL } from "../env";

function config() {
    return {
        BASE: BffBaseURL,
    }
}

export const TimechiefClient = new TC(config());